import React, { useEffect, useRef } from 'react';

// Fond de particules STATIQUE : dessiné une seule fois (et redessiné au resize).
// Aucune boucle d'animation → 0 CPU au repos, rendu fluide et pro.
const ParticlesBackground = () => {
  const canvasRef = useRef(null);

  useEffect(() => {
    const canvas = canvasRef.current;
    const ctx = canvas.getContext('2d');

    const draw = () => {
      canvas.width = window.innerWidth;
      canvas.height = window.innerHeight;
      ctx.clearRect(0, 0, canvas.width, canvas.height);

      // Densité proportionnelle à la surface (cohérent sur tous les écrans)
      const count = Math.min(60, Math.round((canvas.width * canvas.height) / 42000));
      for (let i = 0; i < count; i++) {
        const x = Math.random() * canvas.width;
        const y = Math.random() * canvas.height;
        const size = Math.random() * 1.5 + 0.5;       // 0.5 - 2px
        const opacity = Math.random() * 0.15 + 0.05;   // 0.05 - 0.2 (très discret)
        ctx.beginPath();
        ctx.arc(x, y, size, 0, Math.PI * 2);
        ctx.fillStyle = `rgba(6, 182, 212, ${opacity})`;
        ctx.fill();
      }
    };

    draw();

    // Redessine uniquement au redimensionnement (débounce léger)
    let resizeTimer;
    const onResize = () => {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(draw, 200);
    };
    window.addEventListener('resize', onResize);

    return () => {
      clearTimeout(resizeTimer);
      window.removeEventListener('resize', onResize);
    };
  }, []);

  return (
    <canvas
      ref={canvasRef}
      className="fixed inset-0 pointer-events-none"
      style={{
        zIndex: -1,
        opacity: 0.5
      }}
    />
  );
};

export default ParticlesBackground;
